import script from "./BonusCampaignHeroBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./BonusCampaignHeroBanner.vue?vue&type=script&setup=true&lang=js"

import "./BonusCampaignHeroBanner.vue?vue&type=style&index=0&id=0b65da5c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b65da5c"]])

export default __exports__